
import TheAlert from "../components/TheAlert.vue";
import { Prop } from "vue-property-decorator";
import Component, { mixins } from "vue-class-component";
import { State, Action } from "vuex-class";
import { TokenService } from "@/api/storage";
import { ActionMixin } from "../mixins/ActionMixin";
import LoadingModal from "../components/LoadingModal.vue";
import { api } from "@/api";
import _ from "lodash";
import { MiniProfile } from "@/modules/profile/types";
@Component({
  components: {
    TheAlert,
    LoadingModal,
  },
})
export default class Main extends mixins(ActionMixin) {
  @Prop({ default: "" }) title: any;
  @Prop({ default: "white" }) color: string;
  @Prop({ default: false }) routeFooter: boolean;
  @Prop({ default: "pa-4 px-md-0" }) padding: string;
  @Prop({ default: false }) button: boolean;
  @Prop({ default: "notification" }) actionButton: string;
  @Prop({ default: false }) isProfile: boolean;
  @Prop({ default: false }) loadingFilter: boolean;
  @Prop(Object) debate: any;
  @Prop(Object) community: any;
  @Prop(Number) currentLoadingLoungeId: number;
  @Prop(Boolean) disabled: boolean;
  @Prop(Object) detail: any;
  toggleSidebar: any = null;
  toggleFilter: any = null;
  isNotification = false;
  isMessageNotification = false;
  isNewCommunity = false;
  isPageVisible = true;
  debounce = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchNotification();
    }
  }, 10000);
  debounceCommunity = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchNotificationCommunity();
    }
  }, 600000);
  debounceOnline = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchIsOnline();
    }
  }, 60000);
  debounceTransmission = _.debounce(() => {
    if (this.isPageVisible) {
      this.fetchIsTransmission();
    }
  }, 600000);
  @Action("profile/requestMe") requestMe: any;
  @Action("notification/requestIsNotification") requestIsNotification: any;
  @Action("notification/requestIsMessageNotification")
  requestIsMessageNotification: any;
  @Action("timeline/initializeAxios") initializeAxios: any;
  @State("alertNotification") alertNotification: any;
  @Action("community/requestIsNewCommunity") requestIsNewCommunity: any;
  @Action("community/requestCommunityPending") requestCommunityPending: any;
  @Action("profile/requestIsOnline") requestIsOnline: any;
  @Action("updateAlertNotificationStatus") updateAlertNotificationStatus: any;
  @Action("post/requestCurrentTransmission")
  requestCurrentTransmission: any;
  @Action("timeline/requestBannerImages") requestBannerImages: any;
  @Action("post/requestNextTransmissionList")
  requestNextTransmissionList: any;
  get classContent(): string {
    return `${this.color} ${this.padding}`;
  }
  created(): void {
    this.$root.$i18n.locale = TokenService.getLanguage() || "pt";
    this.$root.$i18n.fallbackLocale = TokenService.getLanguage() || "pt";
    this.setupPageVisibilityListener();
    if (!api) {
      this.initializeAxios().then(() => {
        this.fetchData();
      });
    } else {
      this.fetchData();
    }
  }
  fetchData(): void {
    this.fetchMe();
    this.fetchNotification();
    this.fetchNotificationCommunity();
    this.fetchIsOnline();
    this.fetchBannerImages();
    this.fetchIsTransmission();
  }
  async fetchMe(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestMe().then((data: MiniProfile) => {
        this.$vuetify.theme.dark = data.userTheme === "DARK";
      });
    });
  }
  fetchNotification(): void {
    this.fetchIsNotification();
    this.fetchIsMessageNotification();
  }
  fetchNotificationCommunity(): void {
    this.fetchIsIsNewCommunity();
    this.fetchCommunityNotification();
  }
  async fetchIsNotification(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsNotification().then((data: boolean) => {
        this.isNotification = data;
        this.debounce();
      });
    });
  }
  async fetchIsMessageNotification(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsMessageNotification().then((data: boolean) => {
        this.isMessageNotification = data;
        this.debounce();
      });
    });
  }
  async fetchIsIsNewCommunity(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsNewCommunity().then((data: boolean) => {
        this.isNewCommunity = data;
        if (data)
          setTimeout(() => {
            this.removeNotification();
          }, 5000);
      });
    });
  }
  async fetchCommunityNotification(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestCommunityPending().then(() => {
        this.debounceCommunity();
      });
    });
  }
  async fetchIsOnline(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestIsOnline().then(() => {
        this.debounceOnline();
      });
    });
  }
  async fetchIsTransmission(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestNextTransmissionList().then(() => {
        this.fetchCurrentTransmission();
      });
    });
  }
  async fetchCurrentTransmission(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestCurrentTransmission().then(() => {
        this.debounceTransmission();
      });
    });
  }
  async fetchBannerImages(): Promise<void> {
    await this.withLoading(async () => {
      await this.requestBannerImages();
    });
  }
  removeNotification(): void {
    this.isNewCommunity = false;
  }
  setupPageVisibilityListener(): void {
    // Detecta quando a aba fica visível/invisível
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // Detecta quando a janela perde/ganha foco (complementar ao visibilitychange)
    window.addEventListener("focus", this.handleWindowFocus);
    window.addEventListener("blur", this.handleWindowBlur);
  }
  handleVisibilityChange(): void {
    this.isPageVisible = !document.hidden;

    // Se a aba voltou a ficar visível, executa as chamadas imediatamente
    if (this.isPageVisible) {
      this.fetchNotification();
      this.fetchNotificationCommunity();
      this.fetchIsOnline();
      this.fetchIsTransmission();
    }
  }
  handleWindowFocus(): void {
    this.isPageVisible = true;
    this.fetchNotification();
    this.fetchNotificationCommunity();
    this.fetchIsOnline();
    this.fetchIsTransmission();
  }
  handleWindowBlur(): void {
    this.isPageVisible = false;
  }
  updateToggleSidebar(): void {
    this.toggleSidebar = !this.toggleSidebar;
  }
  updateToggleFilter(): void {
    this.toggleFilter = !this.toggleFilter;
  }

  beforeDestroy(): void {
    this.debounce.cancel();
    this.debounceCommunity.cancel();
    this.debounceOnline.cancel();
    this.debounceTransmission.cancel();

    // Remove os listeners para evitar memory leaks
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("focus", this.handleWindowFocus);
    window.removeEventListener("blur", this.handleWindowBlur);
  }
}
